export const SELECTION_CLASS = 'ricos-selection';
